// extracted by mini-css-extract-plugin
module.exports = {"container":"light_header-module__container--2AROc","wrapper":"light_header-module__wrapper--3-nEn"};